export default __webpack_public_path__ + "static/media/jay.21216fde.jpeg";